export const SearchTypeFileFormatFamily = 26 as const;
export type TSearchTypeFileFormatFamily = typeof SearchTypeFileFormatFamily;
